import { render, staticRenderFns } from "./HistoricoEscalas.vue?vue&type=template&id=3878ca17&"
import script from "./HistoricoEscalas.vue?vue&type=script&lang=js&"
export * from "./HistoricoEscalas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports